export const splitDate = (dateString: string) => {
    return (dateString?.split('T')?.[0] || 'NA');
};